/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Car\CarSelect\CarSelect.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday April 9th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 9th 2024 11:41:37 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { useEffect, useMemo, useState } from "react";

type CarSelectProps = {
    item: string;
    updateCallBack: Function;
    updateKey: string;
    optionsList: string[];
    // optionsList: {id: string, Name: string}[];
    keyTrad: string;
    label?: string;
    disabled: boolean;
};

export default function CarSelect(props: CarSelectProps) {
    const [selected, setSelected] = useState(props.item ?? null);
    const id = `carSelect-${props.keyTrad}-${Math.random()}`;

    useEffect(() => {
        setSelected(props.item);
    }, [props.item]);

    const handleChange = (event: SelectChangeEvent) => {
        setSelected(event.target.value);
        props.updateCallBack(props.updateKey, event.target.value, props.item);
    };

    const buildOpts = () => {
        const rows: JSX.Element[] = [];
        props.optionsList.map(x => rows.push(
            <MenuItem key={`${x}-${Math.random()}`} value={x.toUpperCase()}>
                {props.keyTrad ? translator.decode(`${props.keyTrad}.${x.toLowerCase()}`): x}
            </MenuItem>)
        );
        return rows;
    };

    const carSelectOpts = useMemo<JSX.Element[]>(
        () => buildOpts(), [props.optionsList]
    );

    return (
        <FormControl sx={{ m: 0, minWidth: 190, backgroundColor: "white"}} size="small">
            <InputLabel id={id}>{props.label}</InputLabel>
            <Select
                disabled={!props.disabled}
                labelId={id}
                id={`CarSelect_${Math.random()}`}
                value={selected}
                label={props.label}
                onChange={handleChange}
            >
                {carSelectOpts}
            </Select>
        </FormControl>
    );
};
